var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"user-subscription"}},[_c('img',{staticClass:"photo-preview-remove",class:_vm.hasContent ? 'photo-preview-remove' : 'photo-preview-remove-hide',attrs:{"src":"/images/remove-b.png","id":"subscr-clear"}}),_vm._v(" "),_c('canvas',{attrs:{"id":"subscr-canvas","width":"326","height":"300"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d90dd00","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SubscriptionCanvas.vue
// module id = 129
// module chunks = 0